import React from 'react';
import { I18n } from '@aws-amplify/core';
import FormItem from '@/components/ui/FormItem';
import InputRadio from '@/components/ui/InputRadio';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function WrittenWorkProcedureFormItem({
	fieldName = '',
	required = true
}: Readonly<FormItemProps>): JSX.Element {
	return (
		<FormItem
			required={required}
			label="Written work procedure"
			name={fieldName}
			requiredMessage="Please select a written work procedure"
		>
			<InputRadio
				options={[
					{ label: I18n.get('Yes'), value: true },
					{ label: I18n.get('No'), value: false }
				]}
			/>
		</FormItem>
	);
}
